import { Controller } from "@hotwired/stimulus"

// Searchable filter field list: typing hides sections whose name doesn't match.
export default class extends Controller {
  static targets = ["input", "section", "negate"]

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    this.sectionTargets.forEach((section) => {
      const name = (section.dataset.filterMenuName || "").toLowerCase()
      section.hidden = query !== "" && !name.includes(query)
    })
  }

  // FD-89: flip a section between "is" (include) and "is-not" (exclude). Rewrites
  // the section's field names between `key[]` and `key_not[]` so the right param
  // is posted; selected options stay put so the choice isn't lost. FD-892: the
  // field is a <select> or, for Assignee, shared/_user_picker's checkboxes.
  toggleNegate(event) {
    const button = event.currentTarget
    const key = button.dataset.filterMenuKey
    const section = button.closest("[data-filter-menu-target='section']")
    const fields = section.querySelectorAll(`select[name^="${key}"], input[name^="${key}"]`)
    if (fields.length === 0) return
    const active = button.dataset.active !== "true"
    button.dataset.active = active
    button.textContent = active ? "is not" : "is"
    button.classList.toggle("border-brand", active)
    button.classList.toggle("text-on-surface", active)
    fields.forEach((field) => { field.name = active ? `${key}_not[]` : `${key}[]` })
  }

  // Drop empty/inactive date-filter fields so they don't clutter the URL.
  prune() {
    this.sectionTargets.forEach((section) => {
      const op = section.querySelector('select[name^="filters["]')
      if (!op) return
      const dates = section.querySelectorAll('input[type="date"]')
      if (op.value === "") {
        op.disabled = true
        dates.forEach((d) => (d.disabled = true))
      } else {
        dates.forEach((d) => { if (d.value === "") d.disabled = true })
      }
    })
  }
}
